<template>
  <div class="author-info flex align-center">
    <div class="avatar">
      <img :src="userInfo.image" alt="" />
      <i
        class="sex"
        :style="{
          'background-image':
            'url(' + (userInfo.gender === 'f' ? women : man) + ')',
        }"
      ></i>
    </div>
    <div class="info flex_1">
      <p class="name flex align-center">
        {{ userInfo.nickname }}<span>{{ userInfo.identity }}</span>
      </p>
      <p class="date">{{ currentTime }}</p>
    </div>
    <span
      v-if="isFocus"
      @click="jumpDown"
      class="focus flex align-center justify-center"
      ><i v-if="!userInfo.follow"></i
      ><span>{{ !user.follow ? "关注" : "已关注" }}</span></span
    >
  </div>
</template>

<script>
import Contents from "@/request/base.default.js";
import { navigate, checkWx } from "@/pages/index/custom";

export default {
  props: {
    user: {
      type: [Object],
      default: {},
    },
    time: {
      type: [String],
      default: "",
    },
    isFocus: {
      type: [Boolean],
      default: true,
    },
  },
  data() {
    return {
      userInfo: {},
      currentTime: "",
      man: require("../assets/img/icon_man.png"),
      women: require("../assets/img/icon_women.png"),
    };
  },
  methods: {
    jumpDown() {
      if (checkWx()) {
        navigate("", Contents.downURL + "?mini=1");
      } else {
        navigate("", Contents.downURL);
      }
    },
  },
  created() {
    this.userInfo = this.$props.user;
    this.currentTime = this.$props.time;
  },
};
</script>

<style lang="less" scoped>
.author-info {
  width: 100%;
  height: 2.5rem;
  box-sizing: border-box;
  .avatar {
    width: 2.5rem;
    height: 2.5rem;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .sex {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1rem;
      height: 1rem;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
    }
  }
  .info {
    padding: 0 0.5rem;
    height: 100%;
    .name {
      font-size: 14px;
      font-weight: 500;
      color: #222;
      span {
        width: auto;
        height: 21px;
        display: inline-block;
        background-color: #ffedef;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 76, 103, 1);
        transform: scale(0.75);
        text-align: center;
        line-height: 18px;
        margin-left: 0.25rem;
        padding: 0 0.25rem;
      }
    }
    .date {
      font-size: 12px;
      font-weight: 400;
      color: rgba(167, 167, 167, 1);
      margin-top: 0.25rem;
      line-height: normal !important;
    }
  }
  .focus {
    width: 4.25rem;
    height: 2rem;
    border-radius: 6.25rem;
    line-height: 2rem;
    background: linear-gradient(
      135deg,
      rgba(255, 123, 154, 1) 0%,
      rgba(255, 21, 68, 1) 100%
    );
    span {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
    }
    i {
      width: 1rem;
      height: 100%;
      background: url(../assets/img/icon_focus.png) no-repeat center left;
      background-size: 12px 12px;
    }
  }
}
</style>
